import httpClient from "./httpClient";

const prefix = "/rejections";

export async function getRejectionByApplication(id: number) {
  return (await httpClient.get(prefix + "/get-by-application/" + id)).data;
}

// get-by-application/
